import React from 'react';
import PropTypes from 'prop-types';

import {Row, Col} from 'reactstrap';
import { isPDA } from 'common';
import MagstimHistoryFields from './MagstimHistoryFields';

class MagstimTableData extends React.Component {

    getNamedValuePairs(data) {
        return [];
    }

    render() {

        let pairs = this.getNamedValuePairs(this.props.data);
        const topPadding = isPDA ? 'mt-2' : 'mt-4'

        return (
            <Col className="col">
                <Row className="pt-2 pb-2">
                    <Col className={topPadding}>
                        <MagstimHistoryFields listitems={ pairs } />
                    </Col>
                </Row>
            </Col>
        );
    }
}

MagstimTableData.propTypes = {
    index: PropTypes.number,
    data: PropTypes.object
};

MagstimTableData.defaultProps = {
    index: undefined,
    data: undefined
};


export default MagstimTableData;
